/** Cursor lat/lng readout — ArcGIS-style coordinate HUD. */

interface Props {
  lng: number | null;
  lat: number | null;
}

export function MapCursorReadout({ lng, lat }: Props) {
  /* MSH: with no coordinate under the cursor this painted a permanent
     60x30 "— · —" box in the map's bottom-left. A box whose only content is
     an assertion that it has nothing to say is space with no task, and on a
     touch device it never changes — the pointer never arrives, so the HUD
     sat there for the whole session saying nothing. It now occupies space
     only when it has a coordinate to report. */
  if (lng == null || lat == null) return null;
  return (
    <div className="map-cursor-readout mono" aria-live="polite" title="Cursor coordinates (WGS84)">
      <span>{lat.toFixed(5)}°N</span>
      <span className="map-cursor-sep">·</span>
      <span>{lng.toFixed(5)}°E</span>
    </div>
  );
}
